<template>
  <el-container class="screen-parameters screen-parameters-fullHeight services" v-loading="loading || loadingDelete">
    <el-row class="clients-panel cash-list">
      <el-col :span="20" :offset="2" class="clients-panel-container">
        <el-row class="black-inputs">
          <div class="cash-header">
            <h2>Ouverture et fermeture des services</h2>
            <div class="nav-toggle" @click="showHideScreenServices">
              <div id="nav-icon3" class="open"><span></span><span></span><span></span><span></span></div>
            </div>
          </div>
          <br>
          <el-row class="dateChooser">
            <el-col :md="{ span: 24 }" :sm="{ span: 24 }" :xs="24">
              <el-date-picker class="datePicker" ref="picker" v-model="datesLocked"
                :picker-options="{ firstDayOfWeek: 1 }" type="daterange" range-separator="au"
                start-placeholder="Date de début" end-placeholder="Date de fin" format="dd/MM/yyyy" />
            </el-col>
            <el-col :sm="{ span: 11 }" :xs="24">
              <el-select v-model="serviceState" placeholder="Ouvrir / Fermer">
                <el-option key="0" label="Ouvrir" value="ouvrir">
                </el-option>
                <el-option key="1" label="Fermer" value="fermer">
                </el-option>
              </el-select>
            </el-col>
            <el-col :sm="{ span: 11, offset: 2 }" :xs="24">
              <el-select v-model="serviceLocked" placeholder="Service">
                <el-option v-for="t in getServices" :key="t" :label="t" :value="t">
                </el-option>
              </el-select>
            </el-col>
            <el-col :xs="24" :sm="{ span: 24 }">
              <el-popover v-if="getEntrysIsValid" placement="top" width="200" v-model="popupValid"
                popper-class="popup-delete black-inputs">
                <p>
                  Êtes vous sûr de vouloir<br>
                  {{ serviceState }} {{ (serviceLocked === 'Tous les services') ? serviceLocked.toLowerCase() : `le
                  service du ${serviceLocked.toLowerCase()}` }}<br>
                  du {{ dateRenderer(this.datesLocked[0]) }} - {{ dateRenderer(this.datesLocked[1]) }}
                </p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" class="dark" type="primary" @click="popupValid = false">Annuler</el-button>
                  <el-button type="primary" size="mini" @click="createNewLockedServiceEntry()">Confirmer</el-button>
                </div>
                <el-button class="primary" slot="reference">Valider</el-button>
              </el-popover>
              <el-button type="primary" :disabled="true" v-if="!getEntrysIsValid">Valider</el-button>
            </el-col>
          </el-row>
        </el-row>
      </el-col>
    </el-row>
  </el-container>
</template>

<script>
import { Notification } from 'element-ui';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { arrayOfTimestamp } from '../../tools/timeTool';

export default {
  name: 'LockedServicesList',
  components: {},
  data() {
    return {
      datesLocked: {},
      serviceLocked: '',
      serviceState: '',
      pagesize: 10,
      currentPage: 1,
      total: 0,
      loading: false,
      loadingDelete: false,
      popupValid: false
    }
  },
  computed: {
    ...mapGetters({
      getAllServicesIdsAndName: 'newServices/getAllServicesIdsAndName',
      getLockedDays: 'newServices/getLockedDays',
      getLabelMonth: 'calendar/getLabelMonth'
    }),
    getServices: function () {
      let tabServices = this.getAllServicesIdsAndName.slice()
      tabServices.unshift('Tous les services')
      return tabServices
    },
    getEntrysIsValid: function () {
      if (this.datesLocked.length > 1 &&
        this.serviceLocked !== '' && this.serviceState !== '') {
        return true
      }

      return false
    }
  },
  created: function () { },
  methods: {
    ...mapActions({
      createLockedServices: 'newServices/createLockedServices',
      deleteLockedDays: 'newServices/deleteLockedDays',
      showHideScreenServices: 'displayer/showHideScreenServices',
      showHideLockedService: 'displayer/showHideLockedService'
    }),
    ...mapMutations({
      setDialogError: 'displayer/setDialogError',
      setDialogEditCash: 'displayer/setDialogEditCash',
      setCashEditEntry: 'cash/setCashEditEntry'
    }),
    current_change: function (currentPage) {
      this.currentPage = currentPage
    },
    strUcFirst: function (a) {
      return (`${a}`).charAt(0).toUpperCase() + a.substr(1)
    },
    dateRenderer: function (date) {
      return `${date.getDate()} ${this.getLabelMonth(date.getMonth())} ${date.getFullYear()}`
    },
    successClose: function () {
      Notification.success({
        title: 'Donnée mise à jour pour la fermeture des services',
        message: '',
        position: 'bottom-right'
      })
      this.loading = false
      this.datesLocked = {}
      this.serviceLocked = ''
      this.serviceState = ''
    },
    createNewLockedServiceEntry: function () {
      this.popupValid = false
      // Check entrys
      if (this.getEntrysIsValid) {
        // is valid
        let days = arrayOfTimestamp(this.datesLocked[0], this.datesLocked[1])
        this.loading = true
        // for all services
        if (this.serviceLocked === 'Tous les services') {
          this.getAllServicesIdsAndName.forEach(service => {
            if (this.serviceState === 'fermer') {
              // create entry
              this.createLockedServices({
                days: days,
                service: service
              }).then(() => {
                this.successClose()
              }).catch((err) => {
                console.error(err)
                this.successClose()
              })
            } else {
              this.deleteLockedDays({
                tIds: days,
                service: service
              }).then(() => {
                this.successClose()
              }).catch(err => {
                console.error(err)
                this.successClose()
              })
            }
          })
        } else {
          // create entry for selected service
          if (this.serviceState === 'fermer') {
            this.createLockedServices({
              days: days,
              service: this.serviceLocked
            }).then(() => {
              this.successClose()
            }).catch((err) => {
              console.error(err)
              this.successClose()
            })
          } else {
            this.deleteLockedDays({
              tIds: days,
              service: this.serviceLocked
            }).then(() => {
              this.successClose()
            }).catch(err => {
              console.error(err)
              this.successClose()
            })
          }
        }
      } else {
        // if not valid -> show popup notif error or something like this
        this.setDialogError(true)
      }
    }
  }
}
</script>

<style lang="scss">
@use "../../styles/mixins";

.popup-delete {
  text-align: center;
}

.cash-header {
  position: relative;
  text-align: center;

  .nav-toggle {
    position: absolute;
    right: 0;
    top: -20px;
  }
}

.cash-list {
  button {
    height: 48px;
  }

  .el-col {
    margin-bottom: 20px;

    @include mixins.mobile-landscape {
      margin-bottom: 10px;
    }

    @include mixins.mobile-portrait {
      margin-bottom: 10px;
    }
  }

  .el-range {
    &-editor {
      @include mixins.mobile-portrait {
        height: 100% !important;
        width: 100% !important;
        display: block;
        text-align: center;
      }
    }

    &__icon {
      @include mixins.mobile-portrait {
        display: block;
        width: 100%;
      }
    }

    &-input {
      width: 49%;

      @include mixins.mobile-portrait {
        display: block;
        height: 35px;
        width: 100%;
      }
    }

    &-separator {
      @include mixins.mobile-portrait {
        display: block;
        width: 90%;
      }
    }

    &__close-icon {
      @include mixins.mobile-portrait {
        top: 0;
        right: 10px;
        height: 35px;
        position: absolute;
      }
    }
  }
}

.inputEuro {
  text-align: center;

  &:after {
    content: '€';
    position: absolute;
    font-weight: 100;
    right: 20px;
    font-size: 16px;
  }
}

.el-input__inner {
  text-align: center;
  width: 100%;
}
</style>
